<template>
  <div :ref="refName" />
</template>

<script>
export default {
  props: {
    refName: {
      type: String,
      default: null
    },
    scrollIntoViewBlockOffset: {
      type: Number,
      default: null
    }
  },

  mounted () {
    this.$nextTick(() => {
      if (!this.refName) {
        return
      }

      if (this.scrollIntoViewBlockOffset) {
        this.scrollIntoViewWithOffset(this.scrollIntoViewBlockOffset)
      }
    })
  },

  methods: {
    scrollIntoViewWithOffset (offset) {
      const el = this.$refs[this.refName]
      const rect = el.getBoundingClientRect()
      this.$emit('scroll-request', {
        top: rect.top,
        offset
      })
    }
  }
}
</script>
